import { render, staticRenderFns } from "./BookingContentStatusPending.vue?vue&type=template&id=51b54990&"
import script from "./BookingContentStatusPending.vue?vue&type=script&lang=js&"
export * from "./BookingContentStatusPending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports